// FieldRadar brand (locked artwork — do not redraw).
// `Logo`       → FR mark only (favicon, mobile header, tight squares).
// `LogoLockup` → full FR mark + "FieldRadar.pro" wordmark for light pages.
// `LogoPill`   → the same lockup on a white rounded rectangle for dark navy bars.
const V = "?v=10";
export const BRAND_NAVY = "#0B1C2D";
export const BRAND_TEAL = "#14B8A6";

export function Logo({ size = 40, dark = false }) {
  void dark;
  return (
    <img
      src={`/brand/fr-mark.png${V}`}
      alt="FieldRadar"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
}

export function LogoLockup({ height = 40 }) {
  return (
    <img
      src={`/brand/fr-lockup.png${V}`}
      alt="FieldRadar.pro"
      style={{ height, width: "auto", display: "block" }}
      data-testid="fr-lockup"
    />
  );
}

export function LogoPill({ height = 32, className = "" }) {
  return (
    <span className={`inline-flex items-center bg-white rounded-lg px-2.5 py-1 shadow-sm ${className}`} data-testid="fr-lockup-pill">
      <LogoLockup height={height}/>
    </span>
  );
}

// Text-only wordmark kept for legacy callers; brand rule is to prefer LogoLockup.
export function Wordmark({ dark = false, size = "text-2xl", tagline = true }) {
  return (
    <span className="inline-flex flex-col leading-none whitespace-nowrap">
      <span className={`font-display font-black tracking-tight whitespace-nowrap ${size} ${dark ? "text-white" : "text-[#0B1C2D]"}`}>
        FieldRadar<span style={{ color: BRAND_TEAL }}>.pro</span>
      </span>
      {tagline && (
        <span className={`hidden sm:inline-block text-[9px] font-black uppercase tracking-[0.14em] mt-1 whitespace-nowrap ${dark ? "text-[#14B8A6]" : "text-slate-500"}`}>
          Command Center for the Field
        </span>
      )}
    </span>
  );
}
